{
  "errorCode": "404",
  "errorMessage": "Page not found",
  "goToDashboard": "Go to Dashboard"
}
